module.exports = __webpack_public_path__ + "img/zncs.f6c9cc95.png";